import React, { useState, Fragment } from 'react';

import './ChangePasswordForm.scss';
import { link } from '../../helpers/link';

export default function ChangePasswordForm(props) {
  const [currentStep, changeStep] = useState(1);

  return (
    <section id="changePasswordForm">
      {content(currentStep)}

      {link(
        <span id="verificationCode_link">Terug</span>,
        '/profile-settings',
        props.nextLink
      )}
    </section>
  );

  function content(step) {
    switch (step) {
      case 1:
        return firstStep();
      case 2:
        return secondStep();
      case 3:
        return thirdStep();
    }
  }

  function firstStep() {
    return (
      <Fragment>
        <h2 id="changePasswordForm_title">Wachtwoord wijzigen</h2>

        <p id="changePasswordForm_text">
          Vul je gebruikersnaam, e-mail adres of mobiel telefoonnummer in.
          Vervolgens sturen we je de wachtwoord-reset informatie toe.
        </p>

        <form autoComplete="off" onSubmit={(e) => e.preventDefault(e)}>
          <input autoFocus placeholder="Gebruikersnaam, e-mail, mobiel..." />

          <button onClick={() => changeStep(currentStep + 1)} tabIndex="0">
            Volgende
          </button>
        </form>
      </Fragment>
    );
  }

  function secondStep() {
    return (
      <Fragment>
        <h2 id="changePasswordForm_title">Verificatie code</h2>

        <p id="changePasswordForm_text">
          Vul de ontvangen verificatie code in om je wachtwoord te kunnen
          wijzigen. Geen verificatie code ontvangen? Stuur opnieuw
        </p>

        <form autoComplete="off" onSubmit={(e) => e.preventDefault(e)}>
          <input autoFocus placeholder="6-cijferige verificatie code" />

          <button onClick={() => changeStep(currentStep + 1)} tabIndex="0">
            Volgende
          </button>
        </form>
      </Fragment>
    );
  }

  function thirdStep() {
    return (
      <Fragment>
        <h2 id="changePasswordForm_title">Nieuw wachtwoord instellen</h2>

        <p id="changePasswordForm_text">
          Stel je nieuwe wachtwoord in. Gebruik tenminste 8 tekens, bestaande
          uit cijfers, letters, hoofdletters en tekens.
        </p>

        <form autoComplete="off" onSubmit={(e) => e.preventDefault(e)}>
          <input autoFocus type="password" placeholder="Wachtwoord" />

          <input autoFocus type="password" placeholder="Wachtwoord herhalen" />

          {link(
            <button tabIndex="0">Volgende</button>,
            '/profile-settings',
            props.nextLink
          )}
        </form>
      </Fragment>
    );
  }
}
